export function isAnyOf<TValueType>(value: TValueType, ...values: TValueType[]): boolean {
  return values.includes(value)
}
